import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (phoneNumber: string, onError: () => void) => void;
};

export const PhoneNumberSettingForm: React.FC<Props> = ({ handleSubmit }) => {
  const [hasPhoneNumberError, setHasPhoneNumberError] =
    useState<boolean>(false);

  const schema = useMemo(() => {
    return z.object({
      phoneNumber: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ phoneNumber: "" }}
      onSubmit={({ phoneNumber }) =>
        handleSubmit(phoneNumber, () => setHasPhoneNumberError(true))
      }
    >
      <StyledTextContainer>
        SMS認証を行うため、SMSで認証番号を送信します。SMSが届く電話番号を入力し設定してください。
      </StyledTextContainer>

      <Input
        label="電話番号"
        name="phoneNumber"
        autoFocus
        hasError={hasPhoneNumberError}
        errorMessage="電話番号に半角数字以外が含まれています"
      />

      <StyledFooter>
        <Button variant="filled" text="次へ" type="submit" fullWidth />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;
`;

const StyledFooter = styled.div`
  margin-top: 32px;
`;
